import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NavDailyLogSubmenuPage } from './nav-daily-log-submenu';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    NavDailyLogSubmenuPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(NavDailyLogSubmenuPage),
  ],
})
export class NavDailyLogSubmenuPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-daily-log-submenu/nav-daily-log-submenu.module.ts